/** Prize types as stored in `dbase_prize.typ`. */
export enum DrawingPrizeType {
  GELDGEWINN = 1,
  SACHGEWINN = 2,
}

export interface IDrawingSummaryDigit {
  prizeId: number;
  digits: string;
  typ: DrawingPrizeType;
  /** Prize value in cents. Non-cash prizes carry "000" and use `title`. */
  value: string;
  title: string | null;
}

export interface IDrawingSummaryCount {
  prizeId: number;
  typ: DrawingPrizeType;
  title: string | null;
  /** Prize value in cents. */
  value: string;
  times: number;
  /** times × value, in cents. */
  total: number;
}

/**
 * Payload of `GET /drawing/:id/summary` — everything the overview popup shows.
 * See `doc/specs/drawing-summary.md`.
 */
export interface IDrawingSummary {
  id: number;
  drawingTypeName: string;
  drawingBaseName: string;
  drawingDate: string | null;
  /** Null means the winner mails go out immediately once released. */
  dateWinningNotification: string | null;
  drawingDateNext: string | null;
  datePublish: string | null;
  finalDigits: IDrawingSummaryDigit[];
  prizeCounts: IDrawingSummaryCount[];
  totalCount: number;
  /** Total prize money in cents. */
  totalAmount: number;
}
